import React from "react";

const StaticLatestUpdate = () => {
  return (
    <div style={styles.container}>
      <div style={styles.card}>
        <img src="./images/auction.png" alt="Auction" style={{width:'50%',marginBottom:'20px'}} />
        <div style={styles.header}>നടവരവ് സാധനങ്ങളുടെ പൊതുലേലം</div>

        <h2 style={styles.title}>
           ശ്രീപത്മനാഭസ്വാമി ക്ഷേത്രത്തിൽ നടവരവിനായി ലഭിച്ച സാധനങ്ങൾ പൊതുലേലം വഴി വിൽപ്പന നടത്തുന്നു.
        </h2>

        {/* <p style={styles.description}>
          ശ്രീപത്മനാഭസ്വാമി ക്ഷേത്രത്തിൽ നടവരവിനായി ലഭിച്ച സാധനങ്ങൾ പൊതുലേലം വഴി വിൽപ്പന നടത്തുന്നു.
        </p> */}

        <div style={styles.details}>
          <div style={styles.row}>
            <span style={styles.icon}>📅 &nbsp;</span>
            <span style={styles.lel}>2026 ജൂ​ലൈ 5, ഞായറാഴ്ച</span>
          </div>

          <div style={styles.row}>
            <span style={styles.icon}>📍 &nbsp;</span>
            <span style={styles.lel}>ക്ഷേത്രത്തിനകത്ത് അഗ്രശാല ഗണപതി ക്ഷേത്രത്തിനു സമീപത്തെ മണ്ഡപം</span>
          </div>

          <div style={styles.row}>
            <span style={styles.icon}>⏰ &nbsp;</span>
            <span style={styles.lel}>രാവിലെ 8:30 മുതൽ ഉച്ചയ്ക്ക് 12:30 വരെ</span>
          </div>
        </div>

       
      </div>
    </div>
  );
};

export default StaticLatestUpdate;

const styles = {
  container: {
    display: "flex",
    justifyContent: "center",
    // padding: "40px 20px",
    // background: "#f5efe6",
  },
  card: {
    width: "100%",
    maxWidth: "420px",
    background: "#ffecce",
    borderRadius: "20px",
    padding: "25px",
    boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
    textAlign: "center",
  },
  header: {
    background: "linear-gradient(135deg, #8b0000, #ff6a00)",
    color: "#fff",
    padding: "10px",
    borderRadius: "10px",
    fontWeight: "bold",
    marginBottom: "15px",
    fontFamily:"anek malayalam",
    fontWeight:"600",
    fontSize:"12pt",
  },
  title: {
    fontSize: "15px",
    color: "#333",
    marginBottom: "20px",
     fontFamily:"anek malayalam",
    fontWeight:"600",
    
  },
  description: {
    fontSize: "14px",
    color: "#666",
    marginBottom: "20px",
  },
  details: {
    textAlign: "left",
    marginBottom: "20px",
  },
  row: {
    display: "flex",
    alignItems: "center",
    marginBottom: "15px",
    fontSize: "12px",
    color: "#444",
    borderBottom:"1px solid silver"
  },
  icon: {
    marginRight: "10px",
    fontSize: "18px",
  },
  button: {
    background: "linear-gradient(135deg, #ff8c00, #ff4500)",
    color: "#fff",
    border: "none",
    padding: "12px 25px",
    borderRadius: "25px",
    fontSize: "14px",
    cursor: "pointer",
  },
  lel: {
    fontSize:"12pt",
    fontWeight:"600",
    fontFamily:"anek malayalam"
  }
};